import styled from 'styled-components';

const RadioContainer = styled.div`
  margin: 10px 0;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.6);
`;

export default RadioContainer;
